import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { Formik } from 'formik';
import {
  AppCheckBox,
  AppFormikDatePicker,
  AppFormikTextField,
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { ReactElement } from 'react';
import { apiKeySchema } from 'validators/GuardTrailSchema';

const CreateApiKeyDialog = (props: any): ReactElement => {
  const { open, onCloseApiKey, apiKeyForm, actionOnSubmit, servers } = props;

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => {
          onCloseApiKey(false);
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h3">Create API Key</Typography>
            </Box>
            <IconButton
              onClick={() => {
                onCloseApiKey(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Formik
          initialValues={apiKeyForm}
          validationSchema={apiKeySchema}
          validateOnMount
          enableReinitialize
          onSubmit={(formValues, formik) => {
            actionOnSubmit(formValues, formik);
          }}
        >
          {({ handleSubmit, isSubmitting, isValid, values, setFieldValue }) => (
            <>
              <DialogContent>
                <AppFormikTextField
                  name="name"
                  outerLabel
                  label="Name"
                  placeholder="Production Key"
                />
                <AppFormikTextField
                  name="limit"
                  outerLabel
                  label="Rate Limit (requests per minute)"
                  type="number"
                />
                <AppFormikDatePicker
                  disableToday
                  autoFocus
                  fullWidth
                  className="mb-1"
                  name="expiryDate"
                  testid="datepicker-dropdown"
                  InputProps={{
                    name: 'expiryDate',
                    'aria-labelledby': 'duedate-label',
                    notched: false,
                  }}
                  label="Expires At (optional)"
                  outerLabel
                  min
                  placeholder="gg/mm/aaaa"
                  renderInput={(props: any) => (
                    <TextField {...props} fullWidth margin="normal" />
                  )}
                />

                <Typography>Allowed Servers (leave empty for all)</Typography>
                <Box
                  sx={{
                    border: '1px solid gray',
                    padding: '10px',
                    borderRadius: '5px',
                  }}
                >
                  {servers?.map((server: any) => (
                    <AppCheckBox
                      key={server._id}
                      fullWidth
                      checked={values.allowedServers.includes(server._id)}
                      label={server.name}
                      onChange={(event: any) => {
                        if (event.target.checked) {
                          setFieldValue('allowedServers', [
                            ...values.allowedServers,
                            server._id,
                          ]);
                        } else {
                          setFieldValue(
                            'allowedServers',
                            values.allowedServers.filter(
                              (id: string) => id !== server._id
                            )
                          );
                        }
                      }}
                    />
                  ))}
                </Box>
              </DialogContent>
              <DialogActions>
                <Stack
                  className="mx-4 mb-4"
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <AppPrimaryButtonOutlined
                    title="Cancel"
                    className="btn-small"
                    onClick={() => {
                      onCloseApiKey(false);
                    }}
                  />
                  <AppPrimaryButton
                    isLoading={isSubmitting}
                    onClick={handleSubmit}
                    disabled={!isValid || isSubmitting}
                    loadingText="Saving"
                    title="Create Key"
                    className="btn-small"
                  />
                </Stack>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default CreateApiKeyDialog;
